import {
  BUSCAR_RESERVAS_REMARCACAO, ALTERAR_MARCACAO_RESERVA,
  LIMPAR_RESERVAS_MARCACAO, SELECIONAR_RESERVAS_MARCACAO
} from '../../actions/types'

const initialState = {
  reservas: null,
  reservasSelecionadas: null
}


export default function reducerRemarcacao (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_RESERVAS_REMARCACAO: {
      if (action.payload.reservas) {
        return {
          ...state,
          reservas: action.payload.reservas
            .map(reserva => Object.assign([], reserva, { selecionada: false }))
        }
      }
      return state;
    }
    case ALTERAR_MARCACAO_RESERVA: {
      const reserva = action.payload
      const indice = state.reservas.indexOf(state.reservas.filter(f => f.id === reserva.id)[0])
      const novaReserva = Object.assign({}, reserva, { selecionada: !reserva.selecionada })
      const reservas = Object.assign([], state.reservas)
      reservas[indice] = novaReserva

      return {
        ...state,
        reservas
      }
    }

    case SELECIONAR_RESERVAS_MARCACAO: {
      const reservas = action.payload
      return {
        ...state,
        reservasSelecionadas: reservas
      }
    }

    case LIMPAR_RESERVAS_MARCACAO: {
      return initialState
    }

    default: {
      return state
    }
  }
}
